<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-punkstar">
      <div class="px-3 col-3 p-0">
        <div class="heading-punkstar">{{ $t("result.round") }}</div>
        <div class="text-subhead-punkstar">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-punkstar">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-punkstar">
          {{ (data.bet) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-punkstar">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-punkstar">
          {{ (data.winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-punkstar">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-punkstar">
          {{ (data.balance) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-punkstar pt-3">
      <div class="text-game-punkstar">Punk star</div>
      <div class="text-subgame-punkstar">{{ $t("punkstar.name") }}</div>
      <div class="text-subgame-punkstar"></div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <section v-if="data.detail.state === 'BONUS_GAME'"></section>
      <section v-else>
        <div class="col-12 justify-content-center d-flex flex-row p-5">
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="!isFirst" class="fas fa-caret-left arrow-side-punkstar" @click="delCount()"></i>
          </div>
          <div class="all-table-punkstar container d-flex flex-column justify-content">

            <table>
              <tbody>
                <tr v-for="(row, index) in data.detail.reels[0]" :key="index">
                  <td v-for="(col, i) in data.detail.reels" :key="`${index}${i}`" class="p-0"
                    style="position: relative;text-align: center;">
                    <img class="icon-symbol" :src="require(`../../assets/resultGame/punkstar/symbol_${col[index]
                      }.png`)
                      " alt="" />
                    <section v-if="col[index] === 11">
                      <span bonus-font
                        style="position: absolute;top: 56%;left: 52%;transform: translate(-50%, -50%); color: #dbdb3d;font-size: 3vw;">
                        {{ convertNumberAbbreviated(data.detail.bonusReels[i][index]) }} </span>
                    </section>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-1 d-flex align-items-center justify-content-center">
            <i v-if="!isLast" class="fas fa-caret-right arrow-side-punkstar" @click="addCount()"></i>
          </div>
        </div>
        <div v-if="data.detail.freeSpin.round" class="text-subgame-punkstar mb-1">
          {{
            $t("result.freespin") +
            " " +
            data.detail.freeSpin.round +
            "/" +
            data.detail.freeSpin.totalRound
          }}
        </div>
        <div v-if="data.detail.win > 0 && data.detail.winnings != undefined">
          <div class="col-12 justify-content-center d-flex flex-row">
            <hr class="line col-3" />
            <div class="text-detail align-items-center d-flex px-3">
              {{ $t("result.detail") }}
            </div>
            <hr class="line col-3" />
          </div>
          <div v-if="data.detail.featureBuy" class="col-12 justify-content-center d-flex flex-row">
            <div class="text-subgame-punkstar mb-1"> Feature Buy</div>

          </div>
          <div class="col-12 justify-content-center d-flex flex-row mt-4">
            <div class="bet-box-punkstar p-2 px-3">
              <div class="bet-warpper item" v-for="(block, i) in data.detail.winnings" :key="i">
                <div class="d-flex item justify-content-between px-1 mb-2">
                  <div class="bet-wrapper-punkstar item">
                    <div class="d-flex justify-content-start bet-wrapper-punkstar item">
                      <div class="d-flex flex-column align-items-start justify-content-center">
                        <p class="my-1 yellow">
                          {{ `Line ${block.line + 1}` }}
                        </p>
                      </div>
                      <img class="icon-detail-hcl"
                        :src="require(`../../assets/resultGame/punkstar/symbol_${block.symbol}.png`)" alt="" />
                      <div class="d-flex flex-column align-items-start justify-content-center">
                        <p class="my-1 yellow">
                          {{ `${block.count} ` + $t("result.kind") }}
                        </p>
                      </div>
                      <div class="d-flex flex-column justify-content-center px-3">
                        <p class="my-1">{{ currency }} {{ block.amount | currencyFormatter }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bet-warpper item" v-if="data.detail.winShowsCount === 0">
                <div class="d-flex justify-content-between mt-5">
                  <div class="bet-wrapper-punkstar item align-content-center d-flex">
                    <div class="d-flex justify-content-center bet-wrapper-punkstar item align-content-center p-3">
                      <p class="my-1 red">{{ "No Winnings" }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-punkstar",
  props: {
    data: Object,
  },
  data() {
    // eslint-disable-next-line
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      currency: this.data.currency ? (this.data.detail.isCoin ? 'AMS' : this.data.currency) : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFirst: (this.data.detail.state === 'SPIN'),
      isLast: (this.data.detail.isEndRound)
    };
  },
  async created() {
    if (!this.currency.includes("(")) {
      this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header"
      )[0].offsetHeight;
    },
    async addCount() {
      const countData = this.data.count + 1;
      this.$emit("fetchResult", countData);
    },
    async delCount() {
      const countData = this.data.count - 1;
      this.$emit("fetchResult", countData);
    },
    convertNumberAbbreviated(val) {
      let suffix = ""
      if (val > 999999) {
        val = val / 1000000
        suffix = "M"
      } else if (val > 9999) {
        val = val / 1000
        suffix = "K"
      }
      return String(this.APPLY_EPSILON(val) + suffix);
    },
    getBaseForEPSILON(num) {
      let base = 100;
      if (num > -10 && num < 10) {
        base = 1000
      } else if (num >= 10 && num < 10000) {
        base = 100
      } else if (num >= 10000 && num < 1000000) {
        base = 10
      } else {
        base = 100
      }
      return base;
    },
    APPLY_EPSILON(num) {
      return (Math.round(((num) + Number.EPSILON) * this.getBaseForEPSILON(num)) / this.getBaseForEPSILON(num))
    }
  },
};
</script>

<style scoped>
.bonus-wining {
  width: 230px;
  height: 70px;
  background-color: #153C7A;
  border-radius: 14px;
  color: #ffe463;
}

.icon-detail-hcl {
  width: 90px;
  padding: 10px;
  height: 90px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-punkstar {
  color: #cac095;
  text-align: center;
  font-size: 90px;
}

.bet-box-punkstar {
  background: #000000;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-punkstar .item {
  color: #fff;
  background: #173a7a;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #173a7a;
}

.bet-box-punkstar .bet-wrapper-punkstar:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-punkstar,
.result-wrapper {
  font-size: 35px;
}

.header-punkstar {
  background: #153C7A;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-punkstar {
  color: #ffe463;
  text-align: center;
}

.content-result-punkstar {
  background: #091F43;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-punkstar {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-game-punkstar {
  text-shadow: 0px 0px 20px #ffe463;
  color: #ffe463;
  font-weight: bold;
  font-size: 25px;
  text-align: center;
}

.text-subhead-punkstar {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame-punkstar {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #ffe463;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #ffe463;
  text-align: center;
}

.icon-symbol {
  width: 100%;
}

.bet-box-punkstar {
  min-width: 600px;
  max-width: auto;
}

.all-table-punkstar {
  background: url("~@/assets/resultGame/punkstar/frame.png") no-repeat;
  background-size: 760px 590px;
  width: 770px;
  height: 590px;
  border-radius: 5px;
  font-size: 50px;
  text-align: center;
  padding-top: 18px;
}

.scoreboard-punkstar {
  background: url("~@/assets/resultGame/punkstar/scoreboard.png") no-repeat;
  background-size: 772px 151px;
  width: 772px;
  height: 151px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  padding-top: 18px;
}

@media screen and (max-width: 1030px) {
  .all-table-punkstar {
    background-size: 720px 441px;
    width: 720px;
    height: 441px;
    padding-top: 20px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-punkstar {
    font-size: 60px;
  }

  .bet-box-punkstar {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-punkstar,
  .result-wrapper {
    font-size: 35px;
  }

  .icon-symbol {
    width: 79%;
  }
}

@media screen and (min-width: 1060px) {
  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-punkstar,
  .result-wrapper {
    font-size: 33px;
  }
}

.line {
  background-color: #ffe463;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.yellow {
  color: #ffe463;
}

@media screen and (max-width: 770px) {
  .heading-punkstar {
    font-size: 18px;
  }

  .all-table-punkstar {
    background-size: 486px 326px;
    width: 486px;
    height: 326px;
    padding-top: 20px;
    font-size: 40px;
    ;
  }

  .text-subhead-punkstar {
    font-size: 18px;
  }

  .arrow-side-punkstar {
    font-size: 50px;
  }

  .bet-box-punkstar {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #ffe463;
    text-align: center;
  }

  .container {
    padding-left: 0px;
    padding-right: 0px;
  }

  .bonus-font {
    font-size: 30px;
  }
}

@media screen and (max-width: 480px) {
  .header>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-punkstar {
    font-size: 12px;
  }

  .all-table-punkstar {
    background-size: 204px 190px;
    width: 204px;
    height: 190px;
    padding-top: 10px;
  }

  .text-subhead-punkstar {
    font-size: 14px;
  }

  .bet-box-punkstar {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-punkstar,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-hcl {
    width: 60px;
    height: 60px;
    padding: 5px;
  }

  .contianer-center-parent {
    position: relative;
    text-align: center;
  }

  .bonus-text-inner {
    position: absolute;
    top: 60%;
    left: 40%;
    transform: translate(-50%, -50%);
  }

  span {
    font-size: 18px;
  }
}
</style>
